import ImageMapCreator from './p5.image-map-creator'
import { Area, Map, DrawItem } from '../../types'
import { toShape } from '../../utils'

const DEFAULT_TITLE = 'Untitled'

const itemToArea = (item: DrawItem): Area => ({
    shape: item.shape,
    coords: item.coords,
    title: item.title || DEFAULT_TITLE,
    id: item.generatedId,
    forMobile: item.forMobile,
})

const areaToItem = (area: Area): Omit<DrawItem, 'mapId'> => ({
    shape: toShape(area.shape),
    title: area.title || DEFAULT_TITLE,
    coords: area.coords,
    generatedId: area.id,
})

// Wrapper around image-map-creator
export default (
    elId: string,
    imageMap: Map,
    itemChangeCoordsCallback?: (item: DrawItem, mapItems: DrawItem[]) => void,
    itemCreatedCallback?: (item: DrawItem) => void,
    onGetIsZooming?: (isZooming: boolean) => void
) => {
    const creator = new ImageMapCreator(
        elId,
        imageMap.imageWidth,
        imageMap.imageHeight,
        itemCreatedCallback,
        itemChangeCoordsCallback,
        onGetIsZooming,
    )

    creator.setImage(imageMap.image)

    const getItems = () => creator.getAreas().map(areaToItem)

    return {
        tools: ['polygon', 'rectangle', 'circle', 'select', 'delete', 'cursor'],
        setTool: (t: string) => creator.setTool(t),
        setMouseClicksDisabled: (v: boolean) => {
            creator.mousePressDisabled = v
            creator.emptySelection()
        },
        clear: () => creator.clear(),
        redo: () => creator.redo(),
        undo: () => creator.undo(),
        zoom: (coef) => creator.zoom(coef),
        getItems,
        setItems: (items: DrawItem[]) => {
            creator.clear()
            creator.map.setAreaObjects(items.map(itemToArea))
        },
        setImage: creator.setImage,
    }
}
